export default __webpack_public_path__ + "static/media/water.523bbb08.jpg";